import {
  AUTH_ACTION,
  JWT_DOMAIN,
  REDUX_STATUS,
  USER_CLASS_NAME
} from '@gymaholic/packages'
import createReduxAction from 'modules/redux/actions/create'
import setReduxAction from 'modules/redux/actions/set'
import resetTrainingAuthAction from 'modules/training/modules/app-auth/actions/reset'
import loadProfilesUserActions from 'modules/training/modules/training-users/actions/load-profiles'
import setCurrentTrainingUserAction from 'modules/training/modules/training-users/actions/set-current'
import {
  TRAINING_USERS_ACTION,
  TRAINING_USERS_DOMAIN
} from 'modules/training/modules/training-users/constants'
import { handleNewCustomerDiscountExpiresAtUserAction } from 'modules/training/modules/training-users/actions/handleNewCustomerDiscountExpiresAt/index.js'
import { updateProfileFitnessDataModalShownAtAction } from 'modules/profile/redux/actions/updateProfileFitnessDataModalShownAt/index.js'

function afterLogInTrainingAuthAction (response) {
  return (dispatch) => {
    const {
      user,
      jwt
    } = response.data
    // Add the user
    const data = {
      className: USER_CLASS_NAME,
      data: {
        ...user
      },
      status: REDUX_STATUS.SUCCESS
    }
    const userInstance = dispatch(
      createReduxAction({
        type: TRAINING_USERS_ACTION.CREATE_AFTER_LOG_IN,
        payload: {
          data,
          domainPath: TRAINING_USERS_DOMAIN
        }
      })
    )
    dispatch(setCurrentTrainingUserAction(userInstance))
    // Reset the auth domain
    dispatch(resetTrainingAuthAction())

    // Set the JWT
    dispatch(
      setReduxAction({
        type: AUTH_ACTION.UPDATE_JWT,
        payload: {
          path: JWT_DOMAIN,
          value: jwt
        }
      })
    )

    dispatch(handleNewCustomerDiscountExpiresAtUserAction())
    dispatch(loadProfilesUserActions())

    dispatch(updateProfileFitnessDataModalShownAtAction())

    return user
  }
}

export default afterLogInTrainingAuthAction
